import React from "react";
import { Menu, MenuItem, ListItemIcon, ListItemText, Divider } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CodeIcon from "@mui/icons-material/Code";
import TerminalIcon from "@mui/icons-material/Terminal";

interface ContextMenuProps {
  anchorPosition: { top: number; left: number } | null;
  onClose: () => void;
  onCopyCurl: () => void;
  onCopyFetch: () => void;
  onCopyPowershell: () => void;
  onCopyUrl: () => void;
}

export const ContextMenu: React.FC<ContextMenuProps> = ({
  anchorPosition,
  onClose,
  onCopyCurl,
  onCopyFetch,
  onCopyPowershell,
  onCopyUrl,
}) => {
  return (
    <Menu
      open={Boolean(anchorPosition)}
      onClose={onClose}
      anchorReference="anchorPosition"
      anchorPosition={anchorPosition || undefined}
      slotProps={{
        paper: {
          sx: {
            boxShadow: 3,
            minWidth: 200,
            fontSize: "0.75rem",
          },
        },
      }}
    >
      <MenuItem onClick={onCopyUrl} sx={{ fontSize: "0.75rem", py: 0.75 }}>
        <ListItemIcon>
          <ContentCopyIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary="Copy URL" />
      </MenuItem>
      <Divider />
      <MenuItem onClick={onCopyCurl} sx={{ fontSize: "0.75rem", py: 0.75 }}>
        <ListItemIcon>
          <TerminalIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary="Copy as cURL" />
      </MenuItem>
      <MenuItem onClick={onCopyFetch} sx={{ fontSize: "0.75rem", py: 0.75 }}>
        <ListItemIcon>
          <CodeIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary="Copy as Fetch" />
      </MenuItem>
      <MenuItem onClick={onCopyPowershell} sx={{ fontSize: "0.75rem", py: 0.75 }}>
        <ListItemIcon>
          <TerminalIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary="Copy as PowerShell" />
      </MenuItem>
    </Menu>
  );
};
